// extracted by mini-css-extract-plugin
export var hoverShowDisclaimer = "LightPhoneNumber-module--hover-show-disclaimer--d9fb7";
export var icon = "LightPhoneNumber-module--icon--77838";
export var manualShowDisclaimer = "LightPhoneNumber-module--manual-show-disclaimer--5f232";
export var phoneDisclaimer = "LightPhoneNumber-module--phone-disclaimer--13854";
export var phoneNumber = "LightPhoneNumber-module--phone-number--4c09f";
export var phoneNumberContainer = "LightPhoneNumber-module--phone-number-container--82ef8";
export var text = "LightPhoneNumber-module--text--05a53";